var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vertical menu accordion-menu",attrs:{"id":"sidebarAccordionMenu"}},[_c('the-sidebar-menu-nested',{attrs:{"list":_vm.sideMenu,"hierarchy":_vm.hierarchy,"level":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }